// extracted by mini-css-extract-plugin
export default {"root":"PaymentMethodsRow_root__sWUJU","label":"PaymentMethodsRow_label__VfQNO","method":"PaymentMethodsRow_method__Z2NdX"};